/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface InvestmentStatistics {
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly highest_inv: string;
  readonly lowest_inv: string;
  readonly avg_inv: string;
  readonly median_inv: string;
  readonly rejectability: string;
  readonly drafts_in_system: number;
  readonly unsigned_in_system: number;
  readonly average_investment_overtime: { [key: string]: any };
  readonly age_structure: { [key: string]: any } | null;
  readonly total_invested_successful_pitches: string | null;
  readonly total_invested_by_companies: string | null;
  readonly total_invested_by_companies_successful_pitches: string | null;
  readonly total_invested_by_individuals: string | null;
  readonly total_invested_by_individuals_successful_pitches: string | null;
  readonly total_amount_commited_investments_any_pitches: { [key: string]: any } | null;
  readonly total_amount_commited_investments_successful_pitches: { [key: string]: any } | null;
}
